module.exports = __webpack_public_path__ + "b438637444e4d6f5fae5f6805272fef5.png";